import React, {useContext, useEffect, useState} from 'react'
import {getResponseItem, renderIf, renderIfElse} from "../../Shared";
import getTitle from "../../../helpers/getTitle";
import {Link} from "react-router-dom";
import {Avatar} from "antd";
import {LoginContext} from "../../../components/LoginContext";
import useTranslate from "../../../modules/local/useTranslate";
import {useHistory} from "../../../modules/navigation/useRouter";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {auth_updateInfo_Api, church_getRecommendInfos_Api} from "../../../apis";
import _ from "lodash";
import {GiPopeCrown} from "react-icons/gi";
import getLinkToDetail from 'helpers/getLinkToDetail'
import {BiSolidChurch} from "react-icons/bi";
import {useChurches} from "../../AppLocals/Church/functions/useChurches";
import {ItemInformation} from 'components/common/ItemInformation'
import {isSystemAdmin} from "../../../helpers/authUtils";
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";
import {notifyOnError} from "../../AppLocals/factory/createErrorEvent";
import {NotificationActionTypes, successNotify} from "../../AppLocals/factory/createNotification";
import LoadingBlock from "../../Loading/LoadingBlock";
import {nest} from "recompose";
import Coordinates from "../../../components/Coordinates/Coordinates";
import classNames from "classnames";
import {GoDotFill} from "react-icons/go";
import {staticPaths} from "../../../routes/staticPaths";
import {BsInfoCircleFill} from "react-icons/bs";
import {IoChevronDown} from "react-icons/io5";

const MyPastorsAndTheCatholicChurch = React.memo(({}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const history = useHistory()
    const {isSm} = useContext(LayoutContext)
    const [info, setInfo] = useState(null)

    const {handleAsyncAction: loadChurchInfo} = useAsyncAction({
        apiInfo: church_getRecommendInfos_Api,
        onSuccess: (__, data) => {
            const info = getResponseItem(data?.response)
            setInfo(info)
        },
    })

    const {handleAsyncAction: updateProfileInfo} = useAsyncAction({
        apiInfo: auth_updateInfo_Api,
        prefixStr: 'user@setting@overview',
        onError: notifyOnError(t),
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            loadChurchInfo()
        },
    })

    useEffect(() => {
        loadChurchInfo()
    }, [])

    const {churchModal, showDialog} = useChurches({
        notifyListeners: {}
    })

    const BlockItem = ({item, type}) => {

        const login = useContext(LoginContext)

        const {character, characters = [], diocese, parish, news = [], total_members, total_users} = item ?? {}
        const {church} = diocese ?? {}
        const {churches = []} = parish ?? {}

        const getTitleBlock = (type) => {
            let _title
            switch (type) {
                case 'diocese':
                    _title = diocese?.fullname
                    break;
                case 'parish':
                    _title = parish?.fullname
                    break;
                default:
                    _title = t('The Universal Catholic Church')
                    break;
            }
            return _title
        }
        const getChurch = (type) => {
            switch (type) {
                case 'diocese':
                    return (
                        <div className="flex items-center gap-3">
                            <Avatar
                                size={70} src={character?.photo || diocese?.church?.photo || diocese?.church?.cover_photo}
                                icon={ <BiSolidChurch size={35} className="text-primary-500"/> }
                                className="flex flex-center bg-primary-50"
                            />
                            <div className="flex flex-col flex-1">
                                {character?.position_title && (
                                    <label className="font-medium text-doc-xs text-primary-500 tracking-wider leading-tight">
                                        {character?.position_title ? t(character?.position_title) : ''}
                                    </label>
                                )}
                                {character && (
                                    <Link
                                        target="_blank"
                                        to={getLinkToDetail(character)}
                                        className="font-bold text-lg text-primary no-underline tracking-wide max-lines-1 leading-tight">
                                        {character?.common_name || getTitle(character)}
                                    </Link>
                                )}
                                <span
                                    onClick={() => {showDialog(church)}}
                                    className="mt-2 font-bold text-gray-600 hover:text-primary tracking-wider text-doc-xs italic leading-tight cursor-pointer">
                                    {getTitle(church)}
                                </span>
                            </div>

                        </div>
                    );
                case 'parish':
                    return (
                        <div className="flex items-center gap-3">
                            <Avatar
                                size={70} src={character?.photo || churches[0]?.photo || churches[0]?.cover_photo}
                                icon={ <BiSolidChurch size={30} className="text-blue-400"/> }
                                className="flex flex-center bg-blue-100"
                            />
                            <div className="flex flex-col flex-1">
                                {character?.position_title && (
                                    <label className="font-medium text-sm text-blue-500 tracking-wider leading-tight">
                                        {character?.position_title ? t(character?.position_title) : ''}
                                    </label>
                                )}
                                {character && (
                                    <Link
                                        target="_blank"
                                        to={getLinkToDetail(character)}
                                        className="font-bold text-lg text-blue-600 no-underline tracking-wide max-lines-1 leading-tight">
                                        {character?.common_name || getTitle(character)}
                                    </Link>
                                )}
                                <span
                                    onClick={() => {showDialog(churches[0])}}
                                    className="mt-2 font-bold text-gray-600 hover:text-primary tracking-wider text-doc-xs italic leading-tight cursor-pointer">
                                    {churches[0]?.name}
                                </span>
                            </div>

                        </div>
                    );
                default:
                    return (
                        <div className="flex items-center gap-3">
                            <Avatar
                                size={_.isEmpty(character) ? 70 : 80}
                                src={character?.photo}
                                icon={<GiPopeCrown size={_.isEmpty(character) ? 30 : 40} className="text-yellow-400"/>}
                                className={classNames("flex flex-center", !_.isEmpty(character) ? 'background-200' : 'bg-yellow-100')}
                            />
                            {renderIfElse(
                                !_.isEmpty(character),
                                <div className="flex flex-col flex-1 gap-1">
                                    <span className="font-medium text-yellow-300 tracking-wider leading-tight">
                                        {t(character?.position_title)}
                                    </span>
                                    <Link
                                        target="_blank"
                                        to={getLinkToDetail(character)}
                                        className="font-bold text-2xl text-yellow-400 no-underline tracking-wide max-lines-1 leading-tight">
                                        {character?.common_name || getTitle(character)}
                                    </Link>
                                </div>,
                                <div className="font-bold text-gray-500 tracking-widest">
                                    {t("Sede Vacante")}
                                </div>
                            )}
                        </div>
                    )
            }
        }
        const getLink = (type) => {
            let _link
            // switch (type) {
            //     case 'parish':
            //         _link = staticPaths.dioceses.pathname + `?country=237&diocese-type=DIOCESE&tab=parishes`
            //         break;
            //     case 'diocese':
            //         _link = staticPaths.dioceses.pathname + `?country=237&diocese-type=DIOCESE` || diocese?.websites[0]?.url
            //         break;
            //     default:
            //         break;
            // }
            return _link
        }

        let _className;
        switch (type) {
            case 'diocese':
                _className = 'text-primary-700 border-primary-400';
                break;
            case 'parish':
                _className = 'text-blue-600 border-blue-400';
                break;
            default:
                _className = 'text-yellow-500 border-yellow-300';
                break;
        }

        return (
            renderIf(
                item,
                <div className="p-3 flex flex-col gap-3 background border-t border-color-50 shadow-md rounded-3xl">
                    <div className={classNames("mb-2 pb-1 border-b", _className)}>
                        <label className="font-bold tracking-wider">
                            {getTitleBlock(type)}
                        </label>
                    </div>
                    <div className="flex flex-col gap-2">
                        {getChurch(type)}
                        {characters?.length > 0 && (
                            <div className="flex flex-col">
                                <div className="mb-1 border-b border-color font-medium text-doc-sm text-color-300 tracking-wider">
                                    {t('deputies')}
                                </div>
                                <div className="flex flex-col gap-2">
                                    {characters?.length > 0 && (
                                        characters.map((e, i) => (
                                            <div key={i} className="text-doc-sm space-x-1">
                                                <GoDotFill size={10} className="text-color-500" />
                                                {renderIf(
                                                    e?.position_title,
                                                    <span className="text-color-400">{t(e?.position_title)}</span>
                                                )}
                                                <Link
                                                    target="_blank"
                                                    to={getLinkToDetail(e)}
                                                    className="font-bold text-color-100 no-underline cursor-pointer tracking-widest">
                                                    {e?.common_name || getTitle(e)}
                                                </Link>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="mt-1 flex flex-col gap-1">
                        {type === 'church' && isSystemAdmin(login) && total_members > 0 && (
                            <ItemInformation primary={true} label="member of Kristo"
                                             value={`${Number(total_members).toLocaleString()} ${t('people')}`}
                                             className="text-center text-sm md:text-xs italic"/>
                        )}
                        {type !== 'church' && isSystemAdmin(login) && total_members > 0 && (
                            <div className="flex items-center justify-between">
                                <ItemInformation primary={true} label="member of Kristo"
                                                 value={`${Number(total_members).toLocaleString()} ${t('people')}`}
                                                 className="text-center text-sm md:text-xs italic"/>
                            </div>
                        )}
                        {type !== 'diocese' && type !== 'parish' && isSystemAdmin(login) && total_users > 0 && (
                            <div className="flex items-center justify-between">
                                <ItemInformation primary={true} label="user on Kristo"
                                                 value={`${Number(total_users).toLocaleString()} ${t('people')}`}
                                                 className="text-center text-sm md:text-xs italic"/>
                            </div>
                        )}
                    </div>
                </div>
            )
        )
    }

    if (!info) return <LoadingBlock/>

    return (
        <div className="flex flex-col p-2 bg-gray-300 rounded-3xl">
            <div data-tooltip="pastor & the church" className="flex flex-col gap-3">

                <div className="text-center">
                    <h2 className="text-xl font-semibold text-gray-800 tracking-wider">
                        {t("pastor & the church")}
                    </h2>
                    <div className="w-16 h-1 bg-orange-500 mx-auto mt-1 rounded"/>
                </div>
                <div className="flex flex-col gap-1">
                    <BlockItem item={info?.church}/>

                    <div className="flex flex-col items-center py-1">
                        <div className="w-px h-4 bg-yellow-500 opacity-50"/>
                        <IoChevronDown size={16} className={`text-yellow-600`} />
                    </div>

                    {(_.isEmpty(info?.diocese) && _.isEmpty(info?.parish)) ? (
                        <div id="mandatoryBlock" className="w-full h-full p-3 flex flex-col background border-t border-color-50 shadow-md rounded-3xl">
                            <h2 className="mb-2 pb-1 border-b border-blue-400 font-bold text-blue-600 tracking-wider">
                                {t('diocese')} - {t('parish')}
                            </h2>
                            <p className="mb-4 text-center text-doc-sm text-color-300 tracking-wide">
                                {t("Diocese and parish information has not been updated. Please complete your profile by providing this information.")}
                            </p>
                            <p className="mb-4 text-center text-doc-sm text-color-300 tracking-wide">
                                <BsInfoCircleFill size={12} className="mr-1 text-blue-500"/>
                                {t(
                                    `Click "{update_information}" to go to "{account_settings}" and complete the missing details`,
                                    {
                                        update_information: (
                                            <span className="font-semibold text-color-000 italic">{t('update information')}</span>
                                        ),
                                        account_settings: (
                                            <span className="font-semibold text-color-000 italic">{t('account settings')}</span>
                                        )
                                    }
                                )}
                            </p>
                            <Link
                                id="primaryAction"
                                to={staticPaths.accountSettings.pathname}
                                style={{
                                    padding: '0.75rem', borderRadius: '1rem',
                                    color: '#fff', whiteSpace: 'pre-line',
                                }}
                                className="h-full text-center font-bold text-base shadow-md bg-primary-800 hover:bg-primary no-underline">
                                {t('update information')}
                            </Link>
                        </div>
                    ) : (
                        <>
                            {!_.isEmpty(info?.diocese) && (
                                <React.Fragment>
                                    <BlockItem item={info?.diocese} type="diocese"/>
                                    <div className="flex flex-col items-center py-1">
                                        <div className={`w-px h-4 bg-red-500 opacity-50`}></div>
                                        <IoChevronDown size={16} className={`text-red-600`} />
                                    </div>
                                </React.Fragment>
                            )}
                            {!_.isEmpty(info?.parish) && <BlockItem item={info?.parish} type="parish"/>}
                        </>
                    )}
                </div>
                <div className="text-center font-medium text-doc-sm text-color-300 uppercase tracking-wider">
                    {t('Synodality – Communion – Mission')}
                </div>
            </div>
            {churchModal}
        </div>
    )
})

export default nest(Coordinates, MyPastorsAndTheCatholicChurch)
